
import React from 'react';
import { cn } from '@/lib/utils';
import { CheckIcon } from 'lucide-react';
import { useCostEstimator } from '@/context/CostEstimatorContext';

interface StepIndicatorProps {
  steps: string[];
}

const StepIndicator: React.FC<StepIndicatorProps> = ({ steps }) => {
  const { currentStep, setCurrentStep } = useCostEstimator();

  return (
    <div className="flex justify-between relative">
      {/* Continuous line that spans the full width */}
      <div className="absolute top-1/3 left-0 w-full h-[3px] bg-slate-200 -translate-y-2/4"></div>
      
      {steps.map((step, i) => (
        <div 
          key={i} 
          className={cn(
            "step-item", 
            { 
              "active": currentStep === i + 1,
              "complete": currentStep > i + 1
            }
          )}
        >
          <div 
            className={cn(
              "step cursor-pointer transition-all duration-300 relative z-10 bg-slate-200", 
              { 
                "active": currentStep === i + 1,
                "complete": currentStep > i + 1
              }
            )}
            onClick={() => setCurrentStep(i + 1)}
          >
            {currentStep > i + 1 ? <CheckIcon className="w-5 h-5" /> : i + 1}
          </div>
          <p className="text-sm mt-2">{step}</p>
        </div>
      ))}
      
      {/* Colored progress line */}
      <div 
        className="absolute top-1/3 left-0 h-[3px] bg-primary -translate-y-2/4 transition-all duration-300"
        style={{ 
          width: `${((Math.min(currentStep - 1, steps.length - 1)) / (steps.length - 1)) * 100}%` 
        }}
      ></div>
    </div>
  );
};

export default StepIndicator;
